import { Route, UrlMatchResult, UrlSegment } from '@angular/router';
import { WebsiteLayoutComponent } from './core/layouts/website/website.component';
import { NotFoundComponent } from './pages/notfound/notfound.component';
import { searchResultResolver } from './pages/search-result/guards/search-result.resolver';
import { UrlValidatorGuard } from '@core/guards/url-validator.guard';

export const dataEcolodge = [
  'ویلا',
  'کلبه',
  'خانه‌-آپارتمان',
  'خانه‌-مسافر',
  'اقامتگاه-بومگردی',
  'ساحلی',
  'جنگلی',
];
export const appRoutes: Route[] = [
  {
    path: '',
    component: WebsiteLayoutComponent,
    //canActivateChild: [UrlValidatorGuard],
    children: [
      {
        path: 'notfound',
        component: NotFoundComponent,
      },
      {
        path: '',
        loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'notfound',
        component: NotFoundComponent,
      },
      {
        path: ':city-name',
        redirectTo: ':city-name/',
        pathMatch: 'full',
      },
      {
        path: ':city-name/',
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
      },
      {
        path: ':city-name/map',
        loadComponent: () =>
          import('./shared/components/map/map.component').then((m) => m.MapComponent),
        resolve: { data: searchResultResolver },
        runGuardsAndResolvers: 'always',
      },
      {
        path: ':city-name/map/',
        loadComponent: () =>
          import('./shared/components/map/map.component').then((m) => m.MapComponent),
        resolve: { data: searchResultResolver },
        runGuardsAndResolvers: 'always',
      },
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          let isHotelTypeRoute = false;
          if (segments[1]?.path == 'خانه-مسافر') isHotelTypeRoute = true;
          if (segments[1]?.path == 'جنگلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'تیپ-جنگلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'ساحلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'تیپ-ساحلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'ویلا') isHotelTypeRoute = true;
          if (segments[1]?.path == 'کلبه') isHotelTypeRoute = true;
          if (segments[1]?.path == 'اقامتگاه-بومگردی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'خانه') isHotelTypeRoute = true;

          if (
            segments.length > 1 &&
            segments[0]?.path.includes('ecolodge') &&
            isHotelTypeRoute &&
            segments[2]?.path.includes('map')
          ) {
            return {
              consumed: segments,
              posParams: {
                typeName: new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        loadComponent: () =>
          import('./shared/components/map/map.component').then((m) => m.MapComponent),
        data: { accommodation: 'ecolodge' },
        resolve: { data: searchResultResolver },
      },
      {
        path: 'ecolodge/:city-name/map',
        loadComponent: () =>
          import('./shared/components/map/map.component').then((m) => m.MapComponent),
        data: { accommodation: 'ecolodge' },
        resolve: { data: searchResultResolver },

        runGuardsAndResolvers: 'always',
      },
      {
        path: 'ecolodge/:city-name/map/',
        loadComponent: () =>
          import('./shared/components/map/map.component').then((m) => m.MapComponent),
        data: { accommodation: 'ecolodge' },
        resolve: { data: searchResultResolver },

        runGuardsAndResolvers: 'always',
      },
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          let isHotelTypeRoute = false;
          if (segments[1]?.path == 'خانه-مسافر') isHotelTypeRoute = true;
          if (segments[1]?.path == 'جنگلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'تیپ-جنگلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'ساحلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'تیپ-ساحلی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'ویلا') isHotelTypeRoute = true;
          if (segments[1]?.path == 'کلبه') isHotelTypeRoute = true;
          if (segments[1]?.path == 'اقامتگاه-بومگردی') isHotelTypeRoute = true;
          if (segments[1]?.path == 'خانه') isHotelTypeRoute = true;
          //  dataEcolodge.forEach((item) => {
          //   if (segments[1].path.includes(item)) {
          //    isHotelTypeRoute = true;
          //   }
          //  });

          if (segments.length > 1 && segments[0].path?.includes('ecolodge') && isHotelTypeRoute) {
            return {
              consumed: segments,
              posParams: {
                typeName: new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        data: { type: 'typeName', accommodation: 'ecolodge' },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
      },
      {
        path: 'ecolodge/:city-name',
        data: { accommodation: 'ecolodge' },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
      },
      {
        path: 'ecolodge/search',
        data: { accommodation: 'ecolodge' },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
      },
    
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (
            segments.length > 1 &&
            segments[0].path.includes('-ecolodge') &&
            segments[1].path.includes('-rec')
          ) {
            return {
              consumed: segments,
              posParams: {
                'city-name': new UrlSegment(segments[1].path, {}),
                pageGenerator: new UrlSegment(segments[2].path, {}),
              },
            };
          }
          return null;
        },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
      },
      {
        path: 'ecolodge/:city-name/:resident-name',
        redirectTo: 'ecolodge/:city-name/:resident-name/',
        pathMatch: 'full',
      },
      {
        path: 'ecolodge/:city-name/:resident-name/',
        data: { accommodation: 'ecolodge' },
        loadChildren: () =>
          import('./pages/accommodation-info/accommodation-info.module').then(
            (m) => m.AccommodationInfoModule
          ),
      },
      {
        path: 'ecolodge/:city-name/:house-id/',
        data: { accommodation: 'ecolodge' },
        loadChildren: () =>
          import('./pages/accommodation-info/accommodation-info.module').then(
            (m) => m.AccommodationInfoModule
          ),
      },
      {
        matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
          if (
            segments.length > 1 &&
            (segments[1].path.includes('-rec') || segments[1].path.includes('star'))
          ) {
            return {
              consumed: segments,
              posParams: {
                'city-name': new UrlSegment(segments[0].path, {}),
                pageGenerator: new UrlSegment(segments[1].path, {}),
              },
            };
          }
          return null;
        },
        loadChildren: () =>
          import('./pages/search-result/search-result.module').then((m) => m.SearchResultModule),
      },
      {
        path: ':city-name/:resident-name',
        redirectTo: ':city-name/:resident-name/',
        pathMatch: 'full',
      },
      {
        path: ':city-name/:resident-name/',
        data: { accommodation: 'hotel' },
        loadChildren: () =>
          import('./pages/accommodation-info/accommodation-info.module').then(
            (m) => m.AccommodationInfoModule
          ),
      },
      {
        path: '**',
        //redirectTo: 'notfound',
        component: NotFoundComponent,
        //   canActivate: [UrlValidatorGuard],
        pathMatch: 'full',
      },
    ],
  },
];
